/* ============================================================
   MP Judge.me — fix UI minimo
   Solo: rimozione rotazione date (effetto -90deg che alcuni temi
   applicano per le timestamp). Il resto del widget Judge.me
   mantiene il suo layout default che è già pulito.
   ============================================================ */
(function () {
  'use strict';
  if (document.getElementById('mp-judgeme-fix-style')) return;
  var s = document.createElement('style');
  s.id = 'mp-judgeme-fix-style';
  s.textContent = [
    '.jdgm-rev__timestamp,',
    '.jdgm-rev .jdgm-rev__timestamp {',
    '  transform: none !important;',
    '  -webkit-transform: none !important;',
    '  writing-mode: horizontal-tb !important;',
    '  -webkit-writing-mode: horizontal-tb !important;',
    '  text-orientation: mixed !important;',
    '  font-size: 12.5px !important;',
    '  color: #6b6660 !important;',
    '  letter-spacing: 0 !important;',
    '  font-family: "DM Sans", system-ui, sans-serif !important;',
    '}',
  ].join('\n');
  if (document.head) document.head.appendChild(s);
  else document.addEventListener('DOMContentLoaded', function(){ document.head.appendChild(s); });
})();
